import 'babel-polyfill';
import 'es6-promise/auto';
import Vue from 'vue'
import Vuex from 'vuex'
import { mapState } from 'vuex';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import sessionOrder from './modules/sessionOrder';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    state: {
        isLoading: false,
        loadingTasks: [],
        errors: {},
        allProducts: null,
        holidays: null
    },
    getters,
    actions,
    mutations,
    modules: {
        sessionOrder
    },
});
